import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  document.querySelectorAll('.submenu').forEach((submenu) => {
    const items = submenu.querySelectorAll('.submenu-items [data-mega-target]');
    const panels = submenu.querySelectorAll('[data-mega-panel]');
    const isMegaMenu = submenu.classList.contains('has-mega-menu');
    const panelsContainer = submenu.querySelector('.mega-menu-panels');
    const submenuItems = submenu.querySelector('.submenu-items');

    if (!items.length || !panels.length) return;

    const isDesktop = () => window.innerWidth >= 1024;

    const handlePanelsRelocation = () => {
      if (!isDesktop()) {
        items.forEach((link) => {
          const targetId =
            link.getAttribute('data-mega-target') ||
            link
              .closest('[data-mega-target]')
              ?.getAttribute('data-mega-target');
          if (!targetId) return;

          const panel = submenu.querySelector(
            `[data-mega-panel="${targetId}"]`
          );
          const parentLi = link.closest('li');

          if (panel && parentLi && panel.parentElement !== parentLi) {
            parentLi.appendChild(panel);
          }
        });
      } else {
        if (!panelsContainer) return;
        panels.forEach((panel) => {
          if (panel.parentElement !== panelsContainer) {
            panelsContainer.appendChild(panel);
            panel.style.display = '';
          }
        });
      }
    };

    const handlePosition = () => {
      if (!isDesktop() || !isMegaMenu) {
        submenu.style.left = '';
        return;
      }

      const parentLi = submenu.closest('li');
      const headerInner = submenu.closest('.header__inner');
      if (!parentLi || !headerInner) return;

      const liRect = parentLi.getBoundingClientRect();
      const headerInnerRect = headerInner.getBoundingClientRect();
      const rootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );

      const megaMenuMultiplier = window.innerWidth <= 1200 ? 48.125 : 49.6875;
      const megaMenuWidth = megaMenuMultiplier * rootFontSize;

      const offset = 0.9375 * rootFontSize;
      const availableSpaceRight = headerInnerRect.right - liRect.left - offset;

      if (availableSpaceRight < megaMenuWidth) {
        const offsetLeft = availableSpaceRight - megaMenuWidth;
        const maxNegativeOffset = headerInnerRect.left - liRect.left + offset;
        submenu.style.left = `${Math.max(offsetLeft, maxNegativeOffset)}px`;
      } else {
        submenu.style.left = '0px';
      }
    };

    const getFullElementHeight = (el) => {
      if (!el) return 0;

      const style = window.getComputedStyle(el);
      const marginTop = parseFloat(style.marginTop) || 0;
      const marginBottom = parseFloat(style.marginBottom) || 0;
      const paddingTop = parseFloat(style.paddingTop) || 0;
      const paddingBottom = parseFloat(style.paddingBottom) || 0;

      const isFlexOrGrid = style.display === 'flex' || style.display === 'grid';
      const flexWrap = style.flexWrap;
      const flexDirection = style.flexDirection;

      let contentHeight = 0;

      if (el.children.length > 0) {
        if (isFlexOrGrid && flexDirection !== 'column') {
          if (flexWrap === 'wrap' || flexWrap === 'wrap-reverse') {
            contentHeight = el.scrollHeight - paddingTop - paddingBottom;
          } else {
            Array.from(el.children).forEach((child) => {
              contentHeight = Math.max(contentHeight, child.scrollHeight);
            });
          }
        } else {
          Array.from(el.children).forEach((child) => {
            const childStyle = window.getComputedStyle(child);
            const childMargin =
              (parseFloat(childStyle.marginTop) || 0) +
              (parseFloat(childStyle.marginBottom) || 0);
            contentHeight += child.scrollHeight + childMargin;
          });
        }
      } else {
        contentHeight = el.scrollHeight;
      }

      return (
        contentHeight + paddingTop + paddingBottom + marginTop + marginBottom
      );
    };

    const updateHeight = (activePanelId) => {
      if (!panelsContainer) return;

      if (!isDesktop()) {
        panelsContainer.style.height = '';
        return;
      }

      if (!activePanelId) {
        panelsContainer.style.height = '0px';
        return;
      }

      const activePanel = submenu.querySelector(
        `[data-mega-panel="${activePanelId}"]`
      );
      if (!activePanel) return;

      const prevHeight = panelsContainer.style.height;
      const prevOverflow = panelsContainer.style.overflow;
      panelsContainer.style.overflow = 'visible';
      panelsContainer.style.height = 'auto';

      const descEl = activePanel.querySelector('.mega-menu-panel__desc');
      const brandsEl = activePanel.querySelector('.mega-menu-panel__brands');

      let innerContentHeight = 0;

      if (descEl && brandsEl) {
        innerContentHeight =
          getFullElementHeight(descEl) + getFullElementHeight(brandsEl);
      } else {
        const fallbackEl = descEl || brandsEl || activePanel.firstElementChild;
        innerContentHeight = fallbackEl
          ? getFullElementHeight(fallbackEl)
          : activePanel.scrollHeight;
      }

      const computedStyle = window.getComputedStyle(activePanel);
      const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
      const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
      const targetHeight = innerContentHeight + paddingTop + paddingBottom;
      const minRequiredHeight = submenuItems
        ? submenuItems.getBoundingClientRect().height
        : 0;
      const finalHeight = Math.max(targetHeight, minRequiredHeight);

      panelsContainer.style.overflow = prevOverflow;
      panelsContainer.style.height = prevHeight;

      panelsContainer.getBoundingClientRect();

      panelsContainer.style.height = `${finalHeight}px`;
    };

    const activate = (id) => {
      if (!isDesktop()) return;

      panels.forEach((panel) => {
        panel.classList.toggle(
          'is-active',
          id ? panel.dataset.megaPanel === id : false
        );
      });

      if (id) {
        handlePosition();
        submenu.classList.add('panels-open');
      } else {
        submenu.classList.remove('panels-open');
        if (isMegaMenu) submenu.style.left = '0px';
      }

      if (isMegaMenu) updateHeight(id);
    };

    submenu.querySelectorAll('.submenu-items a').forEach((link) => {
      link.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;

        const megaTarget =
          link.getAttribute('data-mega-target') ||
          link.closest('[data-mega-target]')?.getAttribute('data-mega-target');

        activate(megaTarget || null);
      });
    });

    submenu.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      activate(null);
    });

    window.addEventListener('resize', () => {
      handlePanelsRelocation();

      if (!isDesktop()) {
        submenu.style.left = '';
        submenu.classList.remove('panels-open');
        if (panelsContainer) panelsContainer.style.height = '';
        panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.style.display = panel.closest('li').classList.contains('open')
            ? 'block'
            : 'none';
        });
      } else {
        handlePosition();
        const activePanel = submenu.querySelector('.mega-menu-panel.is-active');
        if (activePanel) {
          updateHeight(activePanel.dataset.megaPanel);
        }
      }
    });

    handlePanelsRelocation();
  });

  const menuButton = document.querySelector('.menu-icon');
  const menu = document.getElementById('main-menu');
  if (!menuButton || !menu) return;

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('is-active');
    menu.classList.toggle('is-active');
  });

  mobileMenuHandler();

  function mobileMenuHandler() {
    const $headerMenu = $('.header-menu');
    const $menuItems = $headerMenu.find('li.menu-item-has-children');
    const $megaItems = $headerMenu.find('li.has-mega-panel');
    const $burgerBtn = $('.menu-icon');

    $menuItems.each(function () {
      if (!$(this).children('.dropdown-toggle').length) {
        $(this).append('<div class="dropdown-toggle"></div>');
      }
    });

    $megaItems.each(function () {
      if (!$(this).children('.mega-toggle').length) {
        $(this).append('<div class="mega-toggle"></div>');
      }
    });

    $headerMenu.on('click touchstart', '.dropdown-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $parent = $(this).closest('li');
      const $submenu = $parent.children('.submenu');
      const $openSiblings = $parent.siblings('li.open');

      if ($openSiblings.length) {
        $openSiblings
          .removeClass('open')
          .children('.submenu, .mega-menu-panel')
          .stop(true, true)
          .slideUp(250);
        $openSiblings
          .find('li.open')
          .removeClass('open')
          .children('.mega-menu-panel')
          .stop(true, true)
          .slideUp(250);
      }

      $parent.toggleClass('open');
      $submenu.stop(true, true).slideToggle(250);
    });

    $headerMenu.on('click touchstart', '.mega-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $parent = $(this).closest('li');
      const $panel = $parent.children('.mega-menu-panel');
      const $openSiblings = $parent.siblings('li.open');

      if ($openSiblings.length) {
        $openSiblings
          .removeClass('open')
          .children('.mega-menu-panel')
          .stop(true, true)
          .slideUp(250);
      }

      $parent.toggleClass('open');
      $panel.stop(true, true).slideToggle(250);
    });

    $burgerBtn.on('click', function () {
      $('body').toggleClass('menu-open');
    });
  }
});
